import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';

const actions = [
  'Open Mifid2 panel',
  'Close Mifid2 panel',
  'Record timestamp',
  'Start negociation',
  'Done deal',
  'Missed deal',
] as const;

type TrackEventAction = (typeof actions)[number];

export function useTrackEvent() {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  return useCallback(
    (action: TrackEventAction, value?: string) => sgwtWebAnalytics?.trackEvent('Mifid2', action, value),
    [sgwtWebAnalytics],
  );
}
